export default "__VITE_ASSET__d27e6aae__"